var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.806,
    height: 115.806,
    viewBox: "0 0 115.806 115.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-422.672 -2100.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53848",
    "data-name": "Group 53848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(443 2120.978)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 37.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-play-circle",
    "data-name": "Icon awesome-play-circle",
    d: "M58.466.563a57.9,57.9,0,1,0,57.9,57.9A57.893,57.893,0,0,0,58.466.563ZM85.479,64.069,44.387,87.651a5.614,5.614,0,0,1-8.335-4.9V34.184a5.617,5.617,0,0,1,8.335-4.9L85.479,54.263A5.621,5.621,0,0,1,85.479,64.069Z",
    transform: "translate(422.109 2099.938)",
    fill: "#1fbdfc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play-btn.5c2c50c866b340524b88f9ac78ee74f8.svg";
export { ForwardRef as ReactComponent };